import { render, staticRenderFns } from "./ModalCadastroGrupoRepasse.vue?vue&type=template&id=12e3c01c"
import script from "./ModalCadastroGrupoRepasse.vue?vue&type=script&lang=ts"
export * from "./ModalCadastroGrupoRepasse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports